<script setup>
import { ArrowUpRight, ArrowRight, Plus, ArrowLeft } from 'lucide-vue-next';

defineProps({
  href: { type: String, default: '#' },
  /** up (external or deeper), right (next), left (back), plus (add) */
  arrow: { type: String, default: 'up' },
  /** orange, ink, light */
  tone: { type: String, default: 'orange' },
  underline: { type: Boolean, default: false },
});
const icons = { up: ArrowUpRight, right: ArrowRight, left: ArrowLeft, plus: Plus };
</script>

<template>
  <a :href="href" class="pd-alink" :class="[`pd-alink--${tone}`, { 'is-under': underline }]">
    <component :is="icons.left" v-if="arrow === 'left'" :size="16" :stroke-width="2.5" aria-hidden="true" />
    <span><slot /></span>
    <component :is="icons[arrow]" v-if="arrow !== 'left'" :size="16" :stroke-width="2.5" aria-hidden="true" class="pd-alink__arrow" />
  </a>
</template>

<style scoped>
.pd-alink {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 800;
  font-size: 0.875rem;
  text-decoration: none;
  padding-bottom: 2px;
}
.pd-alink--orange { color: var(--pd-orange-text); }
.pd-alink--ink { color: inherit; }
.pd-alink--light { color: var(--pd-white); }
.is-under { border-bottom: 2px solid currentColor; padding-bottom: 6px; }
.pd-alink__arrow { transition: transform var(--pd-fast) var(--pd-ease); }
@media (hover: hover) {
  .pd-alink:hover .pd-alink__arrow { transform: translate(2px, -2px); }
}
</style>
